

// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, createStripeConnectAccount } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitCreateStripeConnectProfessionalApi = createAsyncThunk("hitCreateStripeConnectProfessionalApi", async (payload) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("professionalToken")}`,
      },
    };
    const url = ApiBaseUrl + createStripeConnectAccount;
    const response = await axios.post(url, payload, config);
    return response.data;
  } catch (error) {
    showToast(error.response.data.message, "error");
    throw error.response.data;
  }
});

const CreateStripeConnectProfessionalSlice = createSlice({
  name: "createStripeConnectProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitCreateStripeConnectProfessionalData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitCreateStripeConnectProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitCreateStripeConnectProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitCreateStripeConnectProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitCreateStripeConnectProfessionalData } = CreateStripeConnectProfessionalSlice.actions;
export default CreateStripeConnectProfessionalSlice.reducer;
